import {
  Component,
  ViewChild,
  OnInit,
  Input,
  OnDestroy,
  Output,
  EventEmitter,
  AfterViewInit,
  ElementRef
} from '@angular/core';

import {Room, LocalTrack, LocalVideoTrack, LocalAudioTrack, RemoteParticipant} from 'twilio-video';
import {RoomsComponent} from '../rooms/rooms.component';
import {CameraComponent} from '../camera/camera.component';
import {SettingsComponent} from '../settings/settings.component';
import {ParticipantsComponent} from '../participants/participants.component';
import {VideoChatService} from '../../../providers/videochat.service';
import {Observable, Subscription, timer} from "rxjs";
import {AlertController, Platform, PopoverController, ToastController} from "@ionic/angular";
import {Router} from "@angular/router";
import {Survey, SurveyService} from "../../../providers/survey.service";
import {DoctorVisitSurvey} from "../../../models/doctor-visit-survey.model";
import {AlertInput} from "@ionic/core";
import {VetReservation} from "../../../models/vet-reservation.model";
import {HostListener} from '@angular/core';
import {Location, LocationStrategy} from "@angular/common";
import {CommonUtils} from "../../../utils/common";
import {AppStateService} from "../../../providers/app-state.service";

@Component({
  selector: 'app-home-cmp',
  styleUrls: ['./twilio-home.component.scss'],
  templateUrl: './twilio-home.component.html',
})
export class TwilioHomeComponent implements AfterViewInit, OnDestroy {
  @ViewChild('rooms', {static: false}) rooms: RoomsComponent;
  @ViewChild('camera', {static: false}) camera: CameraComponent;
  @ViewChild('settings', {static: false}) settings: SettingsComponent;
  @ViewChild('participants', {static: false}) participants: ParticipantsComponent;

  @ViewChild('remoteCamera', {static: false}) remoteCameraPreviewElement: ElementRef;

  private activeRoom: Room;
  private settingsOn: boolean = false;

  private consultationTimerInSec: number = 0;
  private consultationTimerIsPaused: boolean = false;

  @Input() vetReservation: VetReservation;

  @Output() closeVetReservationComponentRequest = new EventEmitter<boolean>();

  //todo
  private aspectRatio: string = null;
  private roomName: string = '';
  private mute: string = 'mute  ';
  private tracks: LocalTrack[];
  private doctorVisitSurvey: DoctorVisitSurvey;
  private survey: Survey[];
  private surveySubscription: Subscription;
  setPreviewModeTitle: string;
  cantMute: boolean=true;
  isBusy: boolean;
  isBusySub: Subscription;

  constructor(
    private videoChatService: VideoChatService,
    private toastController: ToastController,
    private router: Router,
    private alertCtrl: AlertController,
    private surveyService: SurveyService,
    private locationStrategy: LocationStrategy,
    public commonUtils : CommonUtils,
    private appStateService: AppStateService
  ) {
    history.pushState(null, null, window.location.href);
    this.locationStrategy.onPopState(() => {
      history.pushState(null, null, window.location.href);
      this.closeVetReservationComponent();
    });
  }

  ngAfterViewInit() {
    this.isBusySub = this.appStateService.isBusySubject.subscribe(e=>{this.isBusy=e});
    this.survey = this.surveyService.getSurvey();
    this.setPreviewModeTitle='włącz podgląd';
  }

  private startConsultationTimer() {
    const tt = timer(2000, 1000).subscribe((seconds) => {
      if (!this.consultationTimerIsPaused) this.consultationTimerInSec++;
    })
  }

  private pauseConsultationTimer() {
    this.consultationTimerIsPaused = true;
  }

  private resumeConsultationTimer() {
    this.consultationTimerIsPaused = false;
  }


  async onStart(roomName: string) {
    this.appStateService.updateIsBusySubject(true);
    this.doctorVisitSurvey = new DoctorVisitSurvey();
    this.mute = 'mute';
    if (roomName) {
      if (this.activeRoom) {
        this.activeRoom.disconnect();
      }

      this.camera.finalizePreview();
      this.tracks = await this.settings.showPreviewCamera();

      this.activeRoom =
        await this.videoChatService
          .joinOrCreateRoom(roomName, this.tracks);

        console.log(this.activeRoom.participants)

      if(this.activeRoom?.participants?.size > 0){
        this.startConsultationTimer();
        console.log(this.participants)
      }

      this.participants.initialize(this.activeRoom.participants);
      this.registerRoomEvents();
      this.roomName = roomName

      if (!this.camera.previewIsOn) {
        this.startPreview();
      }
    }

    this.appStateService.updateIsBusySubject(false);
  }

  async onSettingsChanged(deviceInfo: MediaDeviceInfo) {
    await this.camera.initializePreview(deviceInfo);
    this.appStateService.updateIsBusySubject(false);
  }

  async onLeaveRoom(_: boolean) {
    if (this.activeRoom) {
      this.activeRoom.disconnect();
      this.activeRoom = null;
    }

    this.camera.finalizePreview();
    this.participants.clear();
  }

  onParticipantsChanged(_: boolean) {
    this.videoChatService.nudge();
  }

  private registerRoomEvents() {
    this.activeRoom
      .on('disconnected',
        (room: Room) => room.localParticipant.tracks.forEach(publication => this.detachLocalTrack(publication.track)))
      .on('participantConnected',
        (participant: RemoteParticipant) => {
          this.participants.add(participant)
          this.startConsultationTimer();
          console.log(this.activeRoom.participants)

        })
      .on('participantDisconnected',
        (participant: RemoteParticipant) => this.participants.remove(participant))
      .on('dominantSpeakerChanged',
        (dominantSpeaker: RemoteParticipant) => this.participants.loudest(dominantSpeaker));
  }

  private detachLocalTrack(track: LocalTrack) {
    if (this.isDetachable(track)) {
      track.detach().forEach(el => el.remove());
    }
  }

  private isDetachable(track: LocalTrack): track is LocalAudioTrack | LocalVideoTrack {
    return !!track
      && ((track as LocalAudioTrack).detach !== undefined
        || (track as LocalVideoTrack).detach !== undefined);
  }

  async onMute() {
    if (this.mute === 'mute') {
      const videoDevice = this.settings.hidePreviewCamera();
      this.camera.initializePreview(videoDevice);
      this.mute = 'stream again';
    } else {
      let tracks = await this.settings.showPreviewCamera();
      tracks.forEach(e => {
          this.camera.initializePreview(e)
        }
      );
      this.mute = 'mute'
    }
  }

  // onShareScreen() {
  //   if (!screenTrack) {
  //     navigator.mediaDevices.getDisplayMedia().then(stream => {
  //       screenTrack = new Twilio.Video.LocalVideoTrack(stream.getTracks()[0]);
  //       room.localParticipant.publishTrack(screenTrack);
  //       shareScreen.innerHTML = 'Stop sharing';
  //       screenTrack.mediaStreamTrack.onended = () => { shareScreenHandler() };
  //     }).catch(() => {
  //       alert('Could not share the screen.');
  //     });
  //   }
  //   else {
  //     room.localParticipant.unpublishTrack(screenTrack);
  //     screenTrack.stop();
  //     screenTrack = null;
  //     shareScreen.innerHTML = 'Share screen';
  //   }
  // }
  //
  //  getUserScreen(sources, extensionId) {
  //   const request = {
  //     type: 'getUserScreen',
  //     sources: sources
  //   };
  //   return new Promise((resolve, reject) => {
  //     chrome.runtime.sendMessage(extensionId, request, response => {
  //       switch (response && response.type) {
  //         case 'success':
  //           resolve(response.streamId);
  //           break;
  //
  //         case 'error':
  //           reject(new Error(error.message));
  //           break;
  //
  //         default:
  //           reject(new Error('Unknown response'));
  //           break;
  //       }
  //     });
  //   }).then(streamId => {
  //     return navigator.mediaDevices.getUserMedia({
  //       video: {
  //         mandatory: {
  //           chromeMediaSource: 'desktop',
  //           chromeMediaSourceId: streamId,
  //           // You can provide additional constraints. For example,
  //           maxWidth: 1920,
  //           maxHeight: 1080,
  //           maxFrameRate: 10,
  //           minAspectRatio: 1.77
  //         }
  //       }
  //     });
  //   });
  // }

  prepareInputs(question: Survey) {
    return question.answers.map(e => {
      return {
        name: e,
        type: 'radio',
        label: e,
        value: e,
        handler: () => {
          console.log('selected ' + e);
        }
      } as AlertInput
    })
  }

  private async quitNow() {
    if (this.consultationTimerInSec > 5) {
      let survey = this.survey.pop();
      this.consultationTimerInSec = null;
      await this.presentAlertRadio(survey);
    } else {
      this.consultationTimerInSec = null;
      this.closeVetReservationComponent()
    }
  }

  async onQuit() {
    if (!this.participants.isAlone) {
      await this.commonUtils.presentYesNoActionSheet('Na pewno chcesz opuścić konsultację? W pokoju w dalszym ciągu zalogowany jest klient?', 'Tak', 'Nie', 'exit-outline', 'close', () => {
        this.quitNow();
      }, () => {

      });
    } else {
      await this.quitNow();
    }
  }

  closeVetReservationComponent() {
    if (this.vetReservation.isOnline()) {
      if (this.activeRoom) {
        this.onLeaveRoom(true).then(() => {
          this.closeDevice();
          this.closeVetReservationComponentRequest.emit(true);
        });
      } else {
        if (this.tracks) {
          this.tracks.forEach(mediaTrack => {
            mediaTrack.stop();

            if (this.isDetachable(mediaTrack)) {
              mediaTrack.detach().forEach(element => element.remove());
            }
          })
        }

        this.stopPreview();
        this.closeDevice();
        this.closeVetReservationComponentRequest.emit(true);

        this.participants.disconnectAllParticipants();
      }
    } else {
      this.closeVetReservationComponentRequest.emit(true);
    }
  }

  async presentAlertRadio(question: Survey) {
    const alert = await this.alertCtrl.create({
      cssClass: 'my-custom-class',
      header: question.question,
      inputs: this.prepareInputs(question),
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
          }
        }, {
          text: 'Ok',
          handler: () => {
            if (this.survey.length > 0) {
              this.presentAlertRadio(this.survey.pop());
            } else {
              this.closeVetReservationComponent()
            }
            console.log('Confirm Ok');
          }
        }
      ]
    });

    await alert.present();
  }

  ngOnDestroy(): void {
    if (this.surveySubscription) {
      this.surveySubscription.unsubscribe();
    }
    if(this.isBusySub){
      this.isBusySub.unsubscribe();
    }
  }

  showHideSettings() {
    if (this.settingsOn) this.settingsOn = false;
    else this.settingsOn = true;
  }

  startPreview() {
    this.camera.initializePreview().then(() => {
      this.camera.previewIsOn = true;
      this.cantMute=false;
    });
  }

  stopPreview() {
    this.closeDevice();
    this.camera.previewIsOn = false;
    this.cantMute=true;
  }


  private closeTracks(_tracks) {
    if (_tracks) {
      _tracks.forEach(_track => {
        _track.stop();
        _track.detach().forEach(element => element.remove());
      })
    }
  }

  closeDevice() {
    try {
      this.camera.finalizePreview();
      this.camera.finalizeAudioTrack();
      let tr: LocalTrack[] = [];

      this.closeTracks(this.settings.camera.tracks);
      this.closeTracks(this.tracks);
      this.closeTracks(this.camera.localTracks);
    } catch (e) {
      console.error(e);
    }
  }

  actPreviewMode() {
    if(this.camera?.previewIsOn){
    this.stopPreview();
    this.setPreviewModeTitle='włącz podgląd';
    this.cantMute=true;
    } else{
      this.camera.initializePreview().then(() => {
        this.camera.previewIsOn = true;
        this.setPreviewModeTitle='wyłącz podgląd';
        this.cantMute=false;

      });
    }

  }
}
